var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-algorithm-config"},[_c('module-container',{attrs:{"title":_vm.pushTypeName,"show-icon":_vm.stroke - true - _vm.gray - 100,"padding":false}}),_c('scholar-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }